<template>
  <div class="cart-dropdown">
    <button
      class="button cart-dropdown-trigger"
      type="button"
      data-toggle="cart-dropdown"
      @click="doToggleFuturesCart"
    >
      <span v-if="futuresCart.num_bottles > 0" class="badge">
        <span>
          {{ futuresCart.num_bottles }}
        </span>
      </span>
      <span class="sr-only">
        item{{ futuresCart.num_bottles === 1 ? '' : 's' }} in your En Priemur
        Order
      </span>
      <span class="text">Your En Primeur Order</span>
    </button>
    <div
      v-if="futuresCartOpen"
      id="cart-dropdown"
      class="dropdown-pane"
      data-dropdown=""
      data-auto-focus="true"
    >
      <h2 v-html="metadata.constance.EP1_CART_YOUR_ORDER"></h2>
      <ul v-if="futuresCart.lines.length > 0" class="order-simple">
        <li v-for="line in futuresCart.lines" :key="line.id">
          <span :id="`ep-cart-qty-${line.id}`">{{ line.quantity }}x</span>
          <span :id="`ep-cart-name-${line.id}`">{{ line.title }}</span>
        </li>
      </ul>
      <div v-else class="ep-empty-cart-message">
        <strong>Your cart is empty.</strong><br />
        <a href="#" @click.prevent="doToggleFuturesCart">Shop En Primeur</a>
      </div>
      <a
        v-if="futuresCart.lines.length > 0"
        href="#"
        class="btn"
        @click.prevent="$emit('review-order-clicked')"
      >
        View Cart
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FuturesCart',
  emits: ['review-order-clicked'],
  computed: {
    ...mapGetters(['futuresCart', 'futuresCartOpen']),
  },
  created() {
    this.metadata = useMetadata()
  },
  methods: {
    ...mapActions(['doToggleFuturesCart']),
  },
}
</script>
